import React from "react";
import {useNavigate} from "react-router-dom";
import {RECORDS_ROUTE, USERS_ROUTE} from "../../../routes";
import {DATA_LIST_PAGE_SIZE} from "../../../settings";
import {RecordsList} from "../../Widgets/RecordsList/RecordsList";
import {Breadcrumbs} from "../../Widgets/Breadcrumbs/Breadcrumbs";
import {AccessType} from "../../../models/AccessType";
import {StudyType} from "../../Widgets/StudyIcon/StudyIcon";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function Records() {
    const history = useNavigate();
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const recordPath = (id: string) => `${RECORDS_ROUTE}/${id}`;
    const recordClickHandler = (id: string) => {
        history(recordPath(id));
    };
    const studyClickHandler = (id: string, type: StudyType) => {
        switch (type) {
            case StudyType.State:
                recordClickHandler(id);
                break;
            case StudyType.Ecg:
                history(`${RECORDS_ROUTE}/${id}/ecg`)
                break;
            case StudyType.Stethoscope:
                history(`${RECORDS_ROUTE}/${id}/stethoscope`)
                break;
            case StudyType.Spiro:
                history(`${RECORDS_ROUTE}/${id}/spiro`)
                break;
            case StudyType.LtEcg:
                recordClickHandler(id);
                break;
        }
    };
    const userClickHandler = (id: string) => {
        history(`${USERS_ROUTE}/${id}`);
    };
    const openClickHandler = () => {
        if (targetId) {
            recordClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(recordPath(targetId));
        }
    };
    return (
        <div>
            <Breadcrumbs/>
            <RecordsList tag="list_records" pageSize={DATA_LIST_PAGE_SIZE} userId={null} accessType={AccessType.All} patientId={null}
                         recordClickHandler={recordClickHandler} contextMenuHandler={onContextMenu} studyClickHandler={studyClickHandler} userClickHandler={userClickHandler}
                         studyRecordPath={recordPath}/>
            <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                 onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}/>
        </div>
    );
}

export default Records;
